module.exports = __webpack_public_path__ + "static/media/video.c5e4f7f2.svg";